import { ExclamationCircleIcon } from '@heroicons/react/solid';
import { Button, TextButton } from 'components';
import {
  DefaultIncomeQuestionComponentProps,
  StepNamesDefaultIncome,
} from 'questionFlow/flows/defaultIncome/types';
import QuestionOrganism from 'questionFlow/QuestionOrganism';
import { TFunction, Trans, useTranslation } from 'react-i18next';

const cmsLocation = '/questions/income/KonfirError';

const useContent = (t: TFunction<'translation'>) => ({
  title: t(`${cmsLocation}.title`),
  subtitle: t(`${cmsLocation}.subtitle`),
  skipDescription: t(`${cmsLocation}.skipDescription`),
  skipDescriptionLink: t(`${cmsLocation}.skipDescriptionLink`),
});

const stepName = StepNamesDefaultIncome.konfirError;

const KonfirError = ({
  data,
  onSubmit,
  values,
  validationRules,
  ...props
}: DefaultIncomeQuestionComponentProps) => {
  const { t } = useTranslation();
  const content = useContent(t);

  const handleSubmit = (value?: string) => {
    onSubmit({ key: stepName, value });
  };

  return (
    <QuestionOrganism
      id={stepName}
      data-testid={stepName}
      onSubmit={handleSubmit}
      title={content.title}
      subtitle={
        <Trans
          i18nKey={`${cmsLocation}.subtitle`}
          components={{ b: <span className="font-semibold" /> }}
        />
      }
      isFooterHidden
      {...props}
    >
      <div>
        <Button className="mb-10" onClick={() => handleSubmit(StepNamesDefaultIncome.konfir)}>
          <span className="flex flex-row">Try again</span>
        </Button>
      </div>
      <div>
        <p className="flex border-t-2 pt-8" data-testid="manual-upload">
          <ExclamationCircleIcon className="w-5 h-5 mr-5 flex-shrink-0" />
          <span className="text-sm">
            <div className="mb-6">
              <Trans
                i18nKey={`${cmsLocation}.skipDescription`}
                components={{
                  b: <b />,
                }}
              />
            </div>
            <TextButton onClick={() => handleSubmit}>{content.skipDescriptionLink}</TextButton>
          </span>
        </p>
      </div>
      {null}
    </QuestionOrganism>
  );
};

export default KonfirError;
